import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GiftWrappingViewModel } from '@models/api.models';
import { fadeTransition } from '@shared/animations/animations';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { GiftOptionComponent } from '@features/basket-shared/gift-option/gift-option.component';
import { NgFor, NgIf } from '@angular/common';
import { GiftOptionsSliderComponent } from '@features/basket-shared/gift-options-slider/gift-options-slider.component';

@Component({
    selector: 'app-basket-gift-wrapping-options',
    templateUrl: './basket-gift-wrapping-options.component.html',
    styleUrls: ['./basket-gift-wrapping-options.component.scss'],
    animations: [fadeTransition],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GiftOptionsSliderComponent, NgFor, GiftOptionComponent, NgIf, TranslateSafePipe]
})
export class BasketGiftWrappingOptionsComponent implements OnInit {
    public selectedOption?: GiftWrappingViewModel;
    public selectedOptionIndex: number = 0;

    @Input() public options: GiftWrappingViewModel[] = [];
    @Input() public selectedId?: string;

    @Output() public giftWrappingChange: EventEmitter<string> = new EventEmitter<string>();

    public ngOnInit(): void {
        this.selectedOption = this.getOptionByVariantNo(this.selectedId);
        this.selectedOptionIndex = this.getOptionIndex(this.selectedId);
        this.triggerWrappingChange(this.selectedId);
    }

    public selectGiftWrapping(giftWrappingId: string): void {
        this.selectedOption = this.getOptionByVariantNo(giftWrappingId);
        this.triggerWrappingChange(giftWrappingId);
    }

    public trackByVariantNo(index: number, value: GiftWrappingViewModel): string | number {
        return value?.variantNo ?? index;
    }

    private triggerWrappingChange(value: string = ''): void {
        this.giftWrappingChange.emit(value === '0' ? '' : value);
    }

    private getOptionByVariantNo(selectedId?: string): GiftWrappingViewModel | undefined {
        return this.options?.find(option => (selectedId ? option.variantNo === selectedId : option.variantNo === '0'));
    }

    private getOptionIndex(selectedId?: string): number {
        return this.options?.findIndex(option => selectedId === option.variantNo) || 0;
    }
}
